import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "_flexbtwn _ai-c _tc--white" }
const _hoisted_2 = ["href"]
const _hoisted_3 = {
  class: "gfu-bt gfu-bt--b1 _ml-a",
  "data-qa": "mini-wizard-header:AlreadyPledged"
}
const _hoisted_4 = {
  key: 0,
  class: "gfu-bt gfu-bt--caption _tc--white _tar",
  "data-qa": "mini-wizard-item-warning:Tax"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", {
        class: "gfu-bt--caption _ttu",
        href: _ctx.currentPledge.cartDetailsUrl
      }, _toDisplayString($options.orderDetailsLabel), 9 /* TEXT, PROPS */, _hoisted_2),
      _createElementVNode("strong", _hoisted_3, _toDisplayString($options.alreadyPledged), 1 /* TEXT */)
    ]),
    ($options.hasTaxHandlingEnabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($options.taxesSummaryLabel), 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
  ]))
}